/**
 * API Client Entry Point
 * 
 * Main export for the API client with interceptors configured
 */

import apiClient, { API_ENDPOINTS } from './config';
import './interceptors'; // Import to register interceptors

export { API_ENDPOINTS };
export default apiClient;

